import * as React from "react";

function SvgActiveMessages(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="0.8em" height="0.8em" {...props}>
      <path d="M11.55 12.082a.81.81 0 00.9 0L22 5.716V5.5c0-1.24-1.01-2.25-2.25-2.25H4.25C3.01 3.25 2 4.26 2 5.5v.197l9.55 6.385z" />
      <path d="M13.26 13.295a2.266 2.266 0 01-2.52-.001L2 7.452v11.67c0 1.24 1.01 2.25 2.25 2.25h15.5c1.24 0 2.25-1.01 2.25-2.25V7.47l-8.74 5.823z" />
    </svg>
  );
}

export default SvgActiveMessages;
